// removed by extract-text-webpack-plugin
module.exports = {"tagSelect":"tagSelect___r4uhR","expand":"expand___1gA_R","fold":"fold___CHY7W","trigger":"trigger___1HDFY","expandTag":"expandTag___35RmP"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/TagSelect/index.less
// module id = 440
// module chunks = 0 1